// extracted by mini-css-extract-plugin
export default {"modalOverlay":"KK-z","modalContent":"LK-z","header":"MK-z","close":"NK-z"};